module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Termination","periodEnd":"Termination date","terminationFee":"Termination fee"},"et":{"title":"Termination","periodEnd":"Termination date","terminationFee":"Termination fee"},"ru":{"title":"Termination","periodEnd":"Termination date","terminationFee":"Termination fee"}}')
  delete Component.options._Ctor
}
